import request from "@/utils/request";

export function getDeviceId(params){
    return request({
        url:'/extra/getDeviceId',
        method:'post',
        params:params
    })
}
export function getLtPanMiniAppUrl(params){
    return request({
        url:'/extra/getLtPanMiniAppUrl',
        method:'post',
        params:params
    })
}
export function getYunPanLoginUrl(params){
    return request({
        url:'/extra/cmcc/getYunPanLoginUrl',
        method:'post',
        params:params
    })
}

export function getYunPanConfigInfo(params){
    return request({
        url:'/extra/cmcc/getYunPanConfigInfo',
        method:'post',
        params:params
    })
}

export function activeYunWrongPaperBook(params){
    return request({
        url:'/extra/cmcc/activeYunWrongPaperBook',
        method:'post',
        params:params
    })
}
export function getYunPanInfo(params){
    return request({
        url:'/extra/cmcc/getYunPanInfo',
        method:'post',
        params:params
    })
}
export function yunLogout(params){
    return request({
        url:'/extra/cmcc/yunLogout',
        method:'post',
        params:params
    })
}

export function switchAutoSaveWrong(params){
    return request({
        url:'/extra/cmcc/switchAutoSaveWrong',
        method:'post',
        params:params
    })
}

export function getYunWrong(params){
    return request({
        url:'/extra/cmcc/getYunWrong',
        method:'post',
        params:params
    })
}

export function syncYunWrongBook(params){
    return request({
        url:'/extra/cmcc/syncYunWrongBook',
        method:'post',
        params:params
    })
}

export function syncYunWrongBookNoLogin(params){
    return request({
        url:'/extra/cmcc/syncYunWrongBookNoLogin',
        method:'post',
        params:params
    })
}

export function getYunWrongPaperBookList(params){
    return request({
        url:'/extra/cmcc/getYunWrongPaperBookList',
        method:'post',
        params:params
    })
}
export function getYunWrongPaperInfo(params){
    return request({
        url:'/extra/cmcc/getYunWrongPaperInfo',
        method:'post',
        params:params
    })
}
export function sendMessageCode(params){
    return request({
        url:'/extra/woyun/sendMessageCode',
        method:'post',
        params:params
    })
}
export function loginByMobileCode(params){
    return request({
        url:'/extra/woyun/loginByMobileCode',
        method:'post',
        params:params
    })
}

export function activeTelecomYunWrongPaperBook(params){
    return request({
        url:'/extra/telecom/activeYunWrongPaperBook',
        method:'post',
        params:params
    })
}
export function getTelecomYunPanConfigInfo(params){
    return request({
        url:'/extra/telecom/getYunPanConfigInfo',
        method:'post',
        params:params
    })
}

export function getTelecomYunWrongPaperInfo(params){
    return request({
        url:'/extra/telecom/getYunWrongPaperInfo',
        method:'post',
        params:params
    })
}
export function switchTelecomAutoSaveWrong(params){
    return request({
        url:'/extra/telecom/switchAutoSaveWrong',
        method:'post',
        params:params
    })
}

export function getTelecomYunWrongPaperBookList(params){
    return request({
        url:'/extra/telecom/getYunWrongPaperBookList',
        method:'post',
        params:params
    })
}
export function getTelecomYunPanInfo(params){
    return request({
        url:'/extra/telecom/getYunPanInfo',
        method:'post',
        params:params
    })
}
export function getTelecomYunPanLoginUrl(params){
    return request({
        url:'/extra/telecom/getTelecomUnifyAccountLoginUrl',
        method:'post',
        params:params
    })
}
export function telecomYunLogout(params){
    return request({
        url:'/extra/telecom/yunLogout',
        method:'post',
        params:params
    })
}

export function syncTelecomYunWrongBook(params){
    return request({
        url:'/extra/telecom/syncYunWrongBook',
        method:'post',
        params:params
    })
}

export function watchYunPanInit(params){
    return request({
        url:'/extra/watch/yunpan',
        method:'post',
        params:params
    })
}

export function getWatchYunPanConfigInfo(params){
    return request({
        url:'/extra/watch/cmcc/getWatchYunPanConfigInfo',
        method:'post',
        params:params
    })
}
export function watchYunLogout(params){
    return request({
        url:'/extra/watch/cmcc/yunLogout',
        method:'post',
        params:params
    })
}

export function getWatchYunPanLoginUrl(params){
    return request({
        url:'/extra/watch/cmcc/getYunPanLoginUrl',
        method:'post',
        params:params
    })
}
export function getWatchYunPanInfo(params){
    return request({
        url:'/extra/watch/cmcc/getYunPanInfo',
        method:'post',
        params:params
    })
}
export function switchAutoSavePic(params){
    return request({
        url:'/extra/watch/cmcc/switchAutoSavePic',
        method:'post',
        params:params
    })
}

export function getWatchTelecomYunPanConfigInfo(params){
    return request({
        url:'/extra/watch/telecom/getWatchYunPanConfigInfo',
        method:'post',
        params:params
    })
}
export function watchTelecomYunLogout(params){
    return request({
        url:'/extra/watch/telecom/yunLogout',
        method:'post',
        params:params
    })
}

export function getWatchTelecomYunPanLoginUrl(params){
    return request({
        url:'/extra/watch/telecom/getTelecomUnifyAccountLoginUrl',
        method:'post',
        params:params
    })
}
export function getWatchTelecomYunPanInfo(params){
    return request({
        url:'/extra/watch/telecom/getYunPanInfo',
        method:'post',
        params:params
    })
}
export function switchTelecomAutoSavePic(params){
    return request({
        url:'/extra/watch/telecom/switchAutoSavePic',
        method:'post',
        params:params
    })
}


// WEBPACK FOOTER //
// ./src/api/extra.js